(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msw-wishlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__mswWlInit) return;
    window.__mswWlInit = true;

    const KEY = 'msw_wishlist';

    const readLocal = () => {
      try {
        const v = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(v) ? v.filter((h) => typeof h === 'string' && h) : [];
      } catch (e) { return []; }
    };
    const writeLocal = (handles) => {
      try { localStorage.setItem(KEY, JSON.stringify(handles)); } catch (e) { /* storage blocked */ }
    };
    const dispatchChange = () => {
      document.dispatchEvent(new CustomEvent('msw-wish:change', { detail: { handles: readLocal() } }));
    };

    const init = () => {
      const root = document.querySelector('[data-msw-wishlist]');
      if (!root || root.__mswWlDone) return;
      root.__mswWlDone = true;

      const grid = root.querySelector('[data-msw-wish-grid]');
      const empty = root.querySelector('[data-msw-wish-empty]');
      if (!grid) return;

      // shared-list view (?list=h1,h2,...): render THAT list read-only —
      // never merged into localStorage, never rewrites our storage.
      let shared = null;
      const rawList = new URLSearchParams(location.search).get('list');
      if (rawList && /^[a-z0-9,_-]+$/i.test(rawList)) {
        shared = rawList.split(',').filter(Boolean).slice(0, 100);
        if (!shared.length) shared = null;
      }
      const banner = root.querySelector('[data-msw-wish-shared]');
      if (banner) banner.hidden = !shared;
      if (shared) {
        const save = root.querySelector('[data-msw-wish-shared-save]');
        if (save) save.addEventListener('click', () => {
          const cur = readLocal();
          shared.forEach((h) => { if (cur.indexOf(h) === -1) cur.push(h); });
          writeLocal(cur);
          const params = new URLSearchParams(location.search);
          params.delete('list');
          const q = params.toString();
          location.href = location.pathname + (q ? '?' + q : '');
        });
      }

      let display;
      if (shared) {
        display = shared.slice().reverse();
      } else {
        const merged = readLocal();
        dispatchChange(); // refresh hearts/badges
        display = merged.slice().reverse(); // newest first
      }

      const toggleEmpty = () => {
        const has = grid.children.length > 0;
        grid.hidden = !has;
        if (empty) empty.hidden = has;
      };

      if (!display.length) { toggleEmpty(); return; }

      const items = display.map((handle) => {
        const el = document.createElement('div');
        el.className = 'msw-wl__item msw-wl__item--loading';
        el.setAttribute('data-msw-wl-item', handle);
        grid.appendChild(el);
        return el;
      });
      toggleEmpty();

      const pruned = [];
      Promise.allSettled(display.map((handle, i) =>
        fetch('/products/' + encodeURIComponent(handle) + '?section_id=msw-wish-card')
          .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            // Stylesheet subsetting: a Section API response carries the section's CSS in
            // <style data-section-stylesheet>; we inject only the inner node, so adopt it once.
            const css = doc.querySelector('style[data-section-stylesheet]');
            if (css && ![...document.querySelectorAll('style[data-section-stylesheet]')].some((s) => s.textContent === css.textContent)) {
              document.head.appendChild(css);
            }
            const inner = doc.querySelector('[data-msw-wish-card-inner]');
            if (!inner) throw new Error('no card');
            items[i].innerHTML = inner.innerHTML;
            items[i].classList.remove('msw-wl__item--loading');
          })
          .catch((reason) => {
            // Prune ONLY on real 404. Flaky load must not empty the wishlist.
            items[i].remove();
            if (reason === 404) pruned.push(handle);
          })
      )).then(() => {
        if (!shared && pruned.length) writeLocal(readLocal().filter((h) => pruned.indexOf(h) === -1));
        dispatchChange(); // sets .is-wished on the injected hearts
        toggleEmpty();
      });

      // de-wished (heart toggled off on an injected card): remove it from the grid.
      document.addEventListener('msw-wish:change', () => {
        if (shared || !window.MSWWish) return;
        grid.querySelectorAll('[data-msw-wl-item]').forEach((el) => {
          if (!window.MSWWish.has(el.getAttribute('data-msw-wl-item'))) el.remove();
        });
        toggleEmpty();
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
